import React from "react";

const LazyCms = React.lazy(() => import("./cms"));

const Cms = (props: Record<string, any>) => (
  <React.Suspense fallback={null}>
    <LazyCms {...props} />
  </React.Suspense>
);

export default Cms;
